export class SharedEventModel {
    name: string;
    obj: any;
}